/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Pearl_Rich_Wolf_RoarInputs */

const en_pearl_rich_wolf_roar = /** @type {(inputs: Pearl_Rich_Wolf_RoarInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} segments with results enabled`)
};

const de_pearl_rich_wolf_roar = /** @type {(inputs: Pearl_Rich_Wolf_RoarInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Segmente mit aktivierten Ergebnissen`)
};

/**
* | output |
* | --- |
* | "{count} segments with results enabled" |
*
* @param {Pearl_Rich_Wolf_RoarInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pearl_rich_wolf_roar = /** @type {((inputs: Pearl_Rich_Wolf_RoarInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pearl_Rich_Wolf_RoarInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pearl_rich_wolf_roar(inputs)
	return de_pearl_rich_wolf_roar(inputs)
});